// extracted by mini-css-extract-plugin
export default {"mainWrapper":"customer-poc-box_mainWrapper__C8QH4","subWrapper":"customer-poc-box_subWrapper__dkgH6","cardWrapper":"customer-poc-box_cardWrapper__yB5ie"};